import React, { useEffect, useMemo, useRef, useState } from "react";
import "./diwaliGallery26.scss";
import FsLightbox from "fslightbox-react";
import {
  diwalileftarrow,
  diwalirightarrow,
  palyIconRed,
  playIcon25,
  whiteLeftArrow,
} from "../../../images";
import Diwaliheader from "../DiwaliHeader/Diwaliheader";
import Aos from "aos";
import useWindowDimensions from "../../../useWindowDimensions";
import {
  diwaliGallery26PageData,
  diwaliGallery26Tabs,
} from "../../Diwalipage/DiwaliData";
import Swiper, { Navigation } from "swiper";
import DiwaliFooter from "../DiwaliFooter/DiwaliFooter";
import CommonAnimtion from "../CommonAnimtion/CommonAnimtion";
import MetaDecorator from "../../../componentsnew/MetaDecorator/MetaDecorator";
import { useLocation } from "react-router-dom";

Swiper.use([Navigation]);

const BG_VIDEOS = {
  desktop2560: "/videos/BG_2506x1306.mp4",
  desktop1920: "/videos/BG_1920x960.mp4",
  mobile: "/videos/BG_750x1504.mp4",
};

const DiwaliGalleryListing26 = () => {
  const { width } = useWindowDimensions();
  const [activeTab, setActiveTab] = useState("previous");
  const [activeCategory, setActiveCategory] = useState(null);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [vidLink, setVidLink] = useState("");

  const [isInstagramModalOpen, setIsInstagramModalOpen] = useState(false);
  const [instagramLink, setInstagramLink] = useState("");
  const [isInstagramLoading, setIsInstagramLoading] = useState(false);
  const instagramEmbedRef = useRef(null);
  const isMobile = width <= 767;
  const swiperRef = useRef(null);
  const { pathname } = useLocation();

  const getVideoSource = () => {
    if (width >= 2560 && window.innerHeight >= 1440)
      return BG_VIDEOS.desktop2560; // 2560x1306
    if (width <= 2560 && window.innerHeight >= 1440)
      return BG_VIDEOS.desktop2560; // 2560x1306

    return BG_VIDEOS.desktop1920; // 1920x960
  };

  const videoSrc = isMobile ? BG_VIDEOS.mobile : getVideoSource();

  const availableCategories = useMemo(() => {
    return (diwaliGallery26PageData[activeTab] || []).filter(
      (category) => category.items?.length > 0
    );
  }, [activeTab]);

  const displayItems = useMemo(() => {
    if (!activeCategory) {
      return availableCategories.map((category) => ({
        key: category.id,
        isCategory: true,
        id: category.id,
        Name: category.Name,
        img: category.img,
        // alt: category?.alt,
        // latestTitle: category?.latestTitle,
        // lastestDate: category?.lastestDate,
        // lastestUrl: category?.lastestUrl,
        playIcon: category.hasPlayIcon,
      }));
    }

    const selectedCategory = availableCategories.find(
      (category) => category.id === activeCategory
    );

    return (selectedCategory?.items || []).map((item, index) => ({
      key: `${activeCategory}-${index}`,
      isCategory: false,
      ...item,
    }));
  }, [activeCategory, availableCategories]);

  const activeCategoryData = useMemo(() => {
    return availableCategories.find(
      (category) => category.id === activeCategory
    );
  }, [activeCategory, availableCategories]);

  const activeCategoryName = activeCategoryData?.Name;

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setActiveCategory(null);
  };

  const handleCategoryClick = (categoryId) => {
    setActiveCategory(categoryId);
  };

  // const handleItemClick = (item) => {
  //   if (item.ytLink) {
  //     setIsVideoModalOpen(!isVideoModalOpen);
  //     setVidLink(item.ytLink);
  //   }
  // };

  const handleItemClick = (item) => {
    if (item.instagramLink && item.external) {
      window.open(item.instagramLink, "_blank", "noopener,noreferrer");
      return;
    }
    
    if (item.instagramLink) {
      setInstagramLink(item.instagramLink);
      setIsInstagramLoading(true);
      setIsInstagramModalOpen(true);
      return;
    }

    if (item.ytLink) {
      setVidLink(item.ytLink);
      setIsVideoModalOpen((prev) => !prev);
    }
  };

  const diwaliGalleryList = displayItems.map((item) => {
    const showPlayIcon = item.isCategory ? item.playIcon : item.playIcon;
    const playIconSrc = item.isCategory ? palyIconRed : palyIconRed;

    return (
      <div className="swiper-slide" key={item.key}>
        {activeCategoryName === "PR Articles" ? (
          <div className="gallery_box press_box">
            <div className="pressImgWrapper">
              <img src={item?.logo} alt={item?.alt} className="press_img" />
            </div>
            <h3 className="press_title">
              {item?.title?.slice(0, 70)}
              {item?.title?.length > 70 ? "..." : ""}
            </h3>
            <p className="press_date">{item?.date}</p>
            <a
              href={item?.url}
              target="_blank"
              rel="noopener noreferrer"
              className="press_link"
            >
              Read More
            </a>
          </div>
        ) : (
          // : item?.Name === "PR Articles" ? (
          //   <div
          //     className="gallery_box press_box"
          //     onClick={() => handleCategoryClick(item.id)}
          //   >
          //     <div className="pressImgWrapper">
          //       <img src={item?.img} alt={item?.alt} className="press_img" />
          //     </div>
          //     <h3 className="press_title">
          //       {item?.latestTitle?.slice(0, 70)}
          //       {item?.latestTitle?.length > 70 ? "..." : ""}
          //     </h3>
          //     <p className="press_date">{item?.lastestDate}</p>
          //     <a
          //       href={item?.lastestUrl}
          //       target="_blank"
          //       rel="noopener noreferrer"
          //       className="press_link"
          //     >
          //       Read More
          //     </a>
          //   </div>
          // )
          <div
            className="gallery_box"
            onClick={() =>
              item.isCategory
                ? handleCategoryClick(item.id)
                : handleItemClick(item)
            }
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                item.isCategory
                  ? handleCategoryClick(item.id)
                  : handleItemClick(item);
              }
            }}
          >
            <figure
              className={`gallery_img_wrapper ${
                item?.instagramLink ? "gallery_img_wrapper_insta" : ""
              }`}
            >
              <img
                src={item.img}
                alt={item.Name}
                // className="gallery_img"
                className={`gallery_img`}
                loading="lazy"
              />
              {showPlayIcon && (
                <img
                  width={144}
                  src={playIconSrc}
                  alt="play icon"
                  className="diwaliplay"
                />
              )}
            </figure>
            {/* <p className="gallery_text">{item.Name}</p> */}
            {!item?.instagramLink && (
              <p
                className={`gallery_text ${
                  !activeCategory ? "category_text" : ""
                }`}
              >
                {item.Name}
              </p>
            )}
          </div>
        )}
      </div>
    );
  });

  useEffect(() => {
    // 1. Destroy existing instance before creating a new one
    if (swiperRef.current && !swiperRef.current.destroyed) {
      swiperRef.current.destroy(true, true);
    }

    // const diwaliGallerySwiper = new Swiper(
    swiperRef.current = new Swiper(".swiper-container.diwali_gallery_swiper", {
      observer: true,
      observeParents: true,
      centerInsufficientSlides: true,
      spaceBetween: 70,
      navigation: {
        prevEl: ".gallery_swiper_wrapper .left_arrow",
        nextEl: ".gallery_swiper_wrapper .right_arrow",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          slidesPerColumn: 2,
          // slidesPerColumnFill: "column",
          slidesPerColumnFill: "row",
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
        1194: {
          slidesPerView: 3,
          spaceBetween: 70,
        },
        2560: {
          slidesPerView: 3,
          spaceBetween: 70,
        },
      },
    });

    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, true);
      }
    };
  }, [activeTab, activeCategory, displayItems]);

  useEffect(() => {
    if (!isInstagramModalOpen || !instagramLink) return;

    const scriptUrl = "https://www.instagram.com/embed.js";
    let script = document.querySelector(`script[src="${scriptUrl}"]`);

    const processEmbeds = () => {
      window.instgrm?.Embeds?.process();
    };

    if (script) {
      if (window.instgrm?.Embeds) {
        processEmbeds();
      } else {
        script.addEventListener("load", processEmbeds);
      }
    } else {
      script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      script.onload = processEmbeds;
      document.body.appendChild(script);
    }

    return () => {
      script?.removeEventListener("load", processEmbeds);
    };
  }, [isInstagramModalOpen, instagramLink]);

  useEffect(() => {
    if (!isInstagramModalOpen || !instagramLink) return;

    const container = instagramEmbedRef.current;
    if (!container) return;

    let fallbackTimer;
    let observer;

    const stopLoading = () => {
      setIsInstagramLoading(false);
      clearTimeout(fallbackTimer);
      observer?.disconnect();
    };

    // Avoid showing the spinner forever if Instagram is slow.
    fallbackTimer = setTimeout(stopLoading, 15000);

    const attachIframeListener = () => {
      const iframe = container.querySelector("iframe");

      if (iframe && !iframe.dataset.loadingListenerAttached) {
        iframe.dataset.loadingListenerAttached = "true";
        iframe.addEventListener("load", stopLoading, { once: true });
      }
    };

    observer = new MutationObserver(attachIframeListener);

    observer.observe(container, {
      childList: true,
      subtree: true,
    });

    attachIframeListener();

    return () => {
      clearTimeout(fallbackTimer);
      observer.disconnect();
    };
  }, [isInstagramModalOpen, instagramLink]);

  useEffect(() => {
    Aos.init();
    // window.scrollTo(0, 0);

    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, [activeCategory, pathname]);

  return (
    <>
      <MetaDecorator
        metaTitle="Participate in dream big win bigger this festival sweepstake "
        metaDesc="Fill the form to participate in dream big win bigger this festival sweepstake. Win daily vouchers, a gold coin and much more along with a brand new luxury car"
        canonicalLink={window.location.href}
      />
      <div className="main_gallery_26">
        <Diwaliheader />
        <section className="diwali_gallery_sec diwali_gallery_sec_26">
          <div className="bg_wrapper" aria-hidden="true">
            <video
              key={videoSrc}
              className="bg_video"
              width={isMobile ? "750" : "1920"}
              height={isMobile ? "1504" : "960"}
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            >
              <source src={videoSrc} type="video/mp4" />
            </video>
          </div>

          <div
            className="gallery_background"
            data-aos="fade"
            data-aos-duration="2000"
          >
            <section className="gallery_swiper_sec">
              <div className={width < 2000 ? "my_container" : null}>
                <div className="text_container">
                  <h3 className="gallery_heading">GALLERY</h3>
                </div>

                <div className="tabs_gallery--wrapper">
                  {diwaliGallery26Tabs.map(({ id, label }) => (
                    <button
                      key={id}
                      type="button"
                      className={`tabs_gallery ${
                        activeTab === id ? "active" : ""
                      }`}
                      onClick={() => handleTabClick(id)}
                    >
                      {label}
                    </button>
                  ))}
                </div>

                <div className="gallery_swiper_wrapper">
                  <div className="swiper-container diwali_gallery_swiper">
                    <div className="swiper-wrapper">{diwaliGalleryList}</div>
                  </div>
                  {displayItems.length > 3 ? (
                    <div className="navigation_wrapper">
                      <img
                        src={diwalileftarrow}
                        alt=""
                        className="left_arrow"
                        loading="lazy"
                      />
                      <img
                        src={diwalirightarrow}
                        alt=""
                        className="right_arrow"
                        loading="lazy"
                      />
                    </div>
                  ) : null}
                </div>

                {activeCategory && (
                  <button
                    type="button"
                    className="back_btn"
                    onClick={() => setActiveCategory(null)}
                  >
                    <img
                      src={whiteLeftArrow}
                      alt="left arrow"
                      width={19}
                      height={15}
                      className="left_arrow"
                    />
                    <span>GO BACK</span>
                  </button>
                )}
              </div>
            </section>
          </div>
          {/* common animation */}
          <div className="common_animation--gallery">
            <CommonAnimtion playImmediately={true} />
          </div>
        </section>

        <DiwaliFooter />
      </div>
      {/* Instagram post modal */}
      {isInstagramModalOpen && (
        <div
          className="instagram_modal_overlay"
          onClick={() => setIsInstagramModalOpen(false)}
        >
          <div
            className="instagram_modal_content"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="instagram_modal_close"
              onClick={() => {
                setIsInstagramModalOpen(false);
                setIsInstagramLoading(false);
              }}
              aria-label="Close Instagram post"
            >
              &times;
            </button>

            {isInstagramLoading && (
              <div className="instagram_loading">
                <div className="instagram_spinner" />
                <p>Loading Instagram post...</p>
              </div>
            )}

            <div ref={instagramEmbedRef} className="instagram_embed_wrapper">
              <blockquote
                key={instagramLink}
                className="instagram-media"
                data-instgrm-permalink={instagramLink}
                data-instgrm-version="14"
                style={{
                  width: "100%",
                  maxWidth: "540px",
                  margin: "0 auto",
                }}
              >
                <a
                  href={instagramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View this post on Instagram
                </a>
              </blockquote>
            </div>
          </div>
        </div>
      )}

      {/* Existing YouTube modal */}
      <div className="galler_26_diwali_fslightbox">
        <FsLightbox toggler={isVideoModalOpen} sources={[vidLink]} />
      </div>
    </>
  );
};

export default DiwaliGalleryListing26;
